import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Institution} from "../../models/institution";
import {InstitutionRegistrationRelations} from "../../models/institution_registration_relations";
import {PagedData} from "../../models/paged-data";
import {RoleRegistrationRelations} from "../../models/role_registration_relations";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getroleRegistrationsRelationsList(serviceId: string): Observable<RoleRegistrationRelations[][]> {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/role_registration_relations") as Observable<RoleRegistrationRelations[][]>;
  }

  public getRoleRegistrationsRelationsListByPage(serviceId: string, pageSize: number, pageNr: number): Observable<PagedData> {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/role_registration_relations/" + pageSize + "/page/" + pageNr) as Observable<PagedData>;
  }

  public saveRoleRegistrations(serviceId: string, roleRegistrationRelations: RoleRegistrationRelations) {
    Helpers.trimRecursiveObj(roleRegistrationRelations);
    const body = JSON.stringify(roleRegistrationRelations);
    return this.http.post(this.baseUrl + "role_registration_relations", body);
  }

}
